module.exports = __webpack_public_path__ + "img/cert3.5e43a028.png";